import LoadingOverlay from './LoadingOverlay';
import LoadingDelay from './LoadingDelay';
import DelayedLoading from './DelayedLoading';
export default {
  LoadingDelay: LoadingDelay,
  LoadingOverlay: LoadingOverlay,
  DelayedLoading: DelayedLoading
};